export default function sanitizeNumberInput(event) {
  if (event.keyCode === 8 || event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39) {
    return;
  }

  if (!String(event.key).match(/^[0-9]+$/)) {
    event.preventDefault();
  }
}
